export const ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = 'application/json, application/yaml';
export const DEFAULT_BASE_URL = 'https://swagger.io';
export const DEFAULT_OPENAPI_3_SERVER = Object.freeze({
  url: '/'
});